import designTokens from 'theme/design-tokens';

export const SUBMENU_HOVER_DELAY = 150;

export const LEFTNAV_MOBILE_DRAWER_WIDTH = 240;
export const ZINDEX_LEFT_NAV_CONTAINER = String(
  designTokens.zindex.zindexLeftNavContainer
);
export const ZINDEX_LEFTNAV_DRAWER_WRAPPERS = String(
  designTokens.zindex.zindexLeftNavContainer
);

export const LEFTNAV_SUBMENU_ITEM_SCROLL_THRESHOLD = 6;
export const LEFTNAV_SUBMENU_ITEM_HEIGHT = 40;
export const LEFTNAV_SUBMENU_ITEM_PADDING = 8;

export const ZINDEX_OFFSET_LEFT_NAV_DRAWER_LAYER = 1;
export const ZINDEX_OFFSET_LEFT_NAV_PANEL_LAYER = 2;

export const ZINDEX_LEFT_NAV_DRAWER_LAYER =
  parseInt(ZINDEX_LEFT_NAV_CONTAINER, 10) + ZINDEX_OFFSET_LEFT_NAV_DRAWER_LAYER;
export const ZINDEX_LEFT_NAV_PANEL_LAYER =
  parseInt(ZINDEX_LEFT_NAV_CONTAINER, 10) + ZINDEX_OFFSET_LEFT_NAV_PANEL_LAYER;

export const LEFT_NAV_DRAWER_CLIP_MASK_WIDTH = 196;

export const LEFT_COLLAPSED_LEFT_NAV_WIDTH = 68;
export const LEFT_EXPANDED_LEFT_NAV_WIDTH = 196;
export const LEFT_NAV_DRAWER_PADDING = 8;
